import Button from 'components/Button';
import { useState } from 'react';

const SubmitButton = ({ intl, isSubmitDisabled, color }) => {
    // const [textColor, setTextColor] = useState(color);
    const [textColor, setTextColor] = useState('#fff');
    const [bgColor, setBgColor] = useState(color);
    // const [bgColor, setBgColor] = useState('unset');

    return (
        <>
            <Button
                data-sitekey="6LeBiG0aAAAAAL9IidP5LsSMl-PNR_f-GxzOv-TF"
                type="submit"
                disabled={isSubmitDisabled}
                text={intl.formatMessage({
                    id: 'features.Viewlogy.GuestSection.Form.signTheList',
                    defaultMessage: 'Sign guest list',
                })}
                className="g-recaptcha guest-submit-button"
                onMouseEnter={() => {
                    if (!isSubmitDisabled) {
                        setBgColor('#fff');
                        setTextColor(color);
                    }
                }}
                onMouseLeave={() => {
                    if (!isSubmitDisabled) {
                        setBgColor(color);
                        setTextColor('#fff');
                    }
                }}
                style={{
                    color: textColor,
                    border: `2px solid ${color}`,
                    backgroundColor: bgColor,
                    borderRadius: '12px',
                    // opacity: isSubmitDisabled ? '.6' : 'unset',
                    opacity: isSubmitDisabled ? 0.6 : 1,
                    cursor: isSubmitDisabled ? 'default' : 'pointer',
                    transition: 'all 0.2s ease',
                }}
            />
        </>
    );
};

export default SubmitButton;
